
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { SidebarProvider } from './context/SidebarContext';
import { PermissionProvider, usePermission } from './context/PermissionContext';
import './App.css';
// import AnimatedCursor from "react-animated-cursor"
import Login from './pages/components/Login';
import Home from './pages/web/home';
import UserList from './pages/components/UserList'
import Dashboard from './pages/Dashboard';
import NotFound from './pages/components/NotFound';
import AccessDenied from './pages/components/AccessDenied';
import UserDetail from './pages/components/UserDetail';
import UserFullDetail from './pages/components/UserFullDetail';
import Settings from './pages/Settings';
import Announcement from './pages/Announcement';
import StaffList from './pages/access-control/StaffList';
import StaffForm from './pages/access-control/StaffForm';
import StaffDetail from './pages/access-control/StaffDetail';
import RolesList from './pages/access-control/RolesList';
import RoleForm from './pages/access-control/RoleForm';
// import AdsSettings from './pages/components/AdsSettings';
import { Toaster } from 'react-hot-toast';
import WeeklyLeaderboard from './pages/components/Weekly-leaderboard';
import PioneerList from './pages/PioneerList';
import PioneerEmailEditor from './pages/components/PioneerEmailEditor';
import Notifications from './pages/notifications';
import UserChartPage from './pages/components/UserChartPage';
import ProfileVerificationsPage from './pages/ProfileVerifications';
import CreatorHub from './pages/CreatorHub';
import MileStone from './pages/MileStone';
import DeveloperCollaboration from './pages/DeveloperCollaboration';
import DuplicateAccount from './pages/DuplicateAccount';
import EventsList from './pages/events/EventsList';
import EventDetail from './pages/events/EventDetail';
import EventForm from './pages/events/EventForm';
import RewardCoinApproval from './pages/events/RewardCoinApproval';
import TapGame from './pages/games/TapGame';
import BoomCardsGame from './pages/games/BoomCardsGame';
import GamesList from './pages/games/GamesList';
import Game2048 from './pages/games/Game2048';
import FruitCut from './pages/games/FruitCut';
import SlotsGame from './pages/games/SlotsGame';
import SpinWheelGame from './pages/games/SpinWheelGame';
import TasksList from './pages/tasks/TasksList';
import ExchangeOrders from './pages/exchange/ExchangeOrders';
import ExchangeCurrencies from './pages/exchange/ExchangeCurrencies';
import SponsorApplications from './pages/sponsors/SponsorApplications';
import SmsVerification from './pages/sms-verification/SmsVerification';
import KycSettings from './pages/kyc/KycSettings';


const ProtectedRoute = ({ children, module, action = "view" }) => {
  const token = localStorage.getItem("token");
  const { loading, hasPermission } = usePermission();

  if (!token) return <Navigate to="/home" />;
  if (module && !loading && !hasPermission(module, action)) return <AccessDenied />;
  // While the permission profile is still loading, render the page rather
  // than flash Access Denied — the page's own data calls will 403 harmlessly
  // if it turns out the admin really doesn't have access.
  return children;
};

function App() {

  return (
    <SidebarProvider>
    <PermissionProvider>
    <Toaster position="top-right" />
      <Router>
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/home" element={<Home />} />
            <Route path="/dashboard" element={<ProtectedRoute module="dashboard"><Dashboard /></ProtectedRoute>} />
            <Route path="/user" element={<ProtectedRoute module="users"><UserList /></ProtectedRoute>} />
            <Route path="/user/:id" element={<ProtectedRoute module="users"><UserDetail /></ProtectedRoute>} />
            <Route path="/user-full-details/:userId" element={<ProtectedRoute module="users"><UserFullDetail /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute module="setting"><Settings /></ProtectedRoute>} />
            <Route path="/announcement" element={<ProtectedRoute module="announcement"><Announcement /></ProtectedRoute>} />
            <Route path="/weekly-leaderboard" element={<ProtectedRoute module="weekly-leaderboard"><WeeklyLeaderboard /></ProtectedRoute>} />
            <Route path="/event" element={<ProtectedRoute module="event"><EventsList /></ProtectedRoute>} />
            <Route path="/events" element={<ProtectedRoute module="event"><EventsList /></ProtectedRoute>} />
            <Route path="/event/create" element={<ProtectedRoute module="event" action="create"><EventForm /></ProtectedRoute>} />
            <Route path="/events/create" element={<ProtectedRoute module="event" action="create"><EventForm /></ProtectedRoute>} />
            <Route path="/event/:id/edit" element={<ProtectedRoute module="event" action="edit"><EventForm /></ProtectedRoute>} />
            <Route path="/events/:id/edit" element={<ProtectedRoute module="event" action="edit"><EventForm /></ProtectedRoute>} />
            <Route path="/reward-coin-approval" element={<ProtectedRoute module="reward-coin-approval"><RewardCoinApproval /></ProtectedRoute>} />
            <Route path="/event/:id" element={<ProtectedRoute module="event"><EventDetail /></ProtectedRoute>} />
            <Route path="/exchange-orders" element={<ProtectedRoute module="exchange"><ExchangeOrders /></ProtectedRoute>} />
            <Route path="/exchange-currencies" element={<ProtectedRoute module="exchange"><ExchangeCurrencies /></ProtectedRoute>} />
            <Route path="/pioneer-list" element={<ProtectedRoute module="pioneer"><PioneerList /></ProtectedRoute>} />
            <Route path="/pioneer-email" element={<ProtectedRoute module="pioneer"><PioneerEmailEditor /></ProtectedRoute>} />
            <Route path="/creator-hub" element={<ProtectedRoute module="creator-hub"><CreatorHub /></ProtectedRoute>} />
            <Route path="/milestone" element={<ProtectedRoute module="milestone"><MileStone /></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute module="notification"><Notifications /></ProtectedRoute>} />
            <Route path="/chart" element={<ProtectedRoute module="dashboard"><UserChartPage /></ProtectedRoute>} />
            <Route path="/profile-verifications" element={<ProtectedRoute module="profile-verification"><ProfileVerificationsPage /></ProtectedRoute>} />
            <Route path="/developer-collaboration" element={<ProtectedRoute module="devloper-collaboration"><DeveloperCollaboration /></ProtectedRoute>} />
            <Route path="/sponsor-applications" element={<ProtectedRoute module="sponsor-application"><SponsorApplications /></ProtectedRoute>} />
            <Route path="/sms-verification" element={<ProtectedRoute module="sms-verification"><SmsVerification /></ProtectedRoute>} />
            <Route path="/kyc-settings" element={<ProtectedRoute module="kyc-settings"><KycSettings /></ProtectedRoute>} />
            <Route path="/duplicate-account" element={<ProtectedRoute module="duplicate-account"><DuplicateAccount /></ProtectedRoute>} />
            <Route path="/games" element={<ProtectedRoute module="games"><GamesList /></ProtectedRoute>} />
            <Route path="/tap-game" element={<ProtectedRoute module="tap-game"><TapGame /></ProtectedRoute>} />
            <Route path="/boom-cards-game" element={<ProtectedRoute module="boom-cards-game"><BoomCardsGame /></ProtectedRoute>} />
            <Route path="/game-2048" element={<ProtectedRoute module="game-2048"><Game2048 /></ProtectedRoute>} />
            <Route path="/fruit-cut" element={<ProtectedRoute module="fruit-cut"><FruitCut /></ProtectedRoute>} />
            <Route path="/slots-game" element={<ProtectedRoute module="slots-game"><SlotsGame /></ProtectedRoute>} />
            <Route path="/spin-wheel-game" element={<ProtectedRoute module="spin-wheel-game"><SpinWheelGame /></ProtectedRoute>} />
            <Route path="/tasks" element={<ProtectedRoute module="task"><TasksList /></ProtectedRoute>} />

            {/* Access Control */}
            <Route path="/staff" element={<ProtectedRoute module="staff"><StaffList /></ProtectedRoute>} />
            <Route path="/staff/create" element={<ProtectedRoute module="staff" action="create"><StaffForm /></ProtectedRoute>} />
            <Route path="/staff/:id" element={<ProtectedRoute module="staff"><StaffDetail /></ProtectedRoute>} />
            <Route path="/staff/:id/edit" element={<ProtectedRoute module="staff" action="edit"><StaffForm /></ProtectedRoute>} />
            <Route path="/roles" element={<ProtectedRoute module="roles"><RolesList /></ProtectedRoute>} />
            <Route path="/roles/create" element={<ProtectedRoute module="roles" action="create"><RoleForm /></ProtectedRoute>} />
            <Route path="/roles/:id/edit" element={<ProtectedRoute module="roles" action="edit"><RoleForm /></ProtectedRoute>} />

            <Route path="*" element={<NotFound />} />
            {/* <Route path="/ads-settings" element={<AdsSettings />} /> */}
        </Routes>
      </Router>

    {/* <AnimatedCursor
      innerSize={10}
      outerSize={20}
      color='70, 70, 229'
      outerAlpha={0.2}
      innerScale={1}
      outerScale={5}
    /> */}
    </PermissionProvider>
    </SidebarProvider>
  );
}

export default App;
